// export const BASE_URL = "http://192.168.0.134:5001/api/v1";
// export const BASE_URL = "http://192.168.0.124:5000/api/v1";
export const BASE_URL = "https://core.alistore.com.bd/api/v1";
// export const INVENTORY_URL = "http://192.168.0.134:4000/api/v1";
// export const INVENTORY_URL = "http://192.168.0.124:4000/api/v1";
export const INVENTORY_URL = "https://inventory.alistore.com.bd/api/v1";

export const CDN = "https://cdn.alistore.com.bd";
